import { TFunction } from "i18next";
import { T_oAuth2Type, t_warningTexts } from "@i18n/usualTexts/t_warningTexts";

interface ErrorMessages {
  username: {
    errorType: string;
    formatError: string;
    invalidException: string;
  };
  password: {
    errorType: string;
    formatError: string;
    invalidException: string;
  };
}

const errorType = {
  username: "UserNotFoundError",
  password: "InvalidUserCredentialsError",
};

interface ErrorHandler {
  matches: (error: any, type: string) => boolean;
  handle: (
    error: any,
    type: string,
    setServerErrorPopUp: React.Dispatch<React.SetStateAction<string | null>>,
    fieldErrors: Set<string>,
    t: TFunction<"translation", undefined>
  ) => void;
}

const errorHandlers: ErrorHandler[] = [
  {
    matches: (error) => !!error.error,
    handle: (_error, type, _setPopUp, fieldErrors, t) =>
      fieldErrors.add(t(t_warningTexts.oAuth2[type as keyof T_oAuth2Type].formatError)),
  },
  {
    matches: (error) => !!error.description,
    handle: (error, _type, _setPopUp, fieldErrors) =>
      fieldErrors.add(error.description[1]),
  },
  {
    matches: (error) => error.body?.title === "InvalidConfirmationCodeError",
    handle: (_error, _type, _setPopUp, fieldErrors, t) =>
      fieldErrors.add(t(t_warningTexts.signup.code)),
  },
  {
    matches: (error) => !!error.body?.exception_uuid,
    handle: (error, _type, setPopUp) =>
      setPopUp(error.body.exception_uuid),
  },
  {
    matches: (error, type) => error.body?.title === errorType[type as keyof ErrorMessages],
    handle: (_error, type, _setPopUp, fieldErrors, t) =>
      fieldErrors.add(t(t_warningTexts.oAuth2[type as keyof T_oAuth2Type].invalidException)),
  },
  {
    matches: (error) => !!error.body,
    handle: (error, _type, setPopUp) =>
      setPopUp(error.body.title),
  },
  {
    matches: (error) => !!error.message,
    handle: (error, _type, setPopUp) =>
      setPopUp(error.message),
  },
];

export function showAuthError(
  type: string,
  error: any,
  setServerErrorPopUp: React.Dispatch<React.SetStateAction<string | null>>,
  fieldErrors: Set<string>,
  t: TFunction<"translation", undefined>
) {
  console.log(error);
  fieldErrors.clear();

  const handler = errorHandlers.find((h) => h.matches(error, type));
  handler?.handle(error, type, setServerErrorPopUp, fieldErrors, t);
}
